import { Component } from "@angular/core"
import { AlertController, ViewController, LoadingController, ToastController } from "ionic-angular"

import firebase from "firebase"

@Component({
  selector: "profile-email-page",
  templateUrl: "email.html",
})
export class ProfileEmailPage {

  newEmail = ""
  currentPassword = ""

  constructor(
    private alertCtrl: AlertController,
    private viewCtrl: ViewController,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController
  ) {}

  onCancel() {

    this.viewCtrl.dismiss()
  }

  onUpdate() {

    if (!this.validData())
      return

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.present()

    const user = firebase.auth().currentUser

    firebase.auth().signInWithEmailAndPassword(user.email, this.currentPassword)
      .then(() => user.updateEmail(this.newEmail))
      .then(() => firebase.database().ref(`users/${user.uid}`).update({ email: this.newEmail }))
      .then(() => {

        loading.dismiss()
        this.viewCtrl.dismiss(this.newEmail)

        this.toastCtrl.create({
          message: "E-mail alterado com sucesso",
          duration: 3000,
        }).present()
      })
      .catch((error: any) => {

        console.log(error)

        let message = "Falha ao alterar e-mail"
        const errorCode = error.toJSON().code

        if (errorCode == "auth/wrong-password") {
          message = "Senha inválida"
        } else if (errorCode == "auth/email-already-in-use") {
          message = "E-mail já cadastrado"
        }

        loading.dismiss()

        this.alertCtrl.create({
          message,
          buttons: ["Ok"]
        }).present()
      })
  }

  validData() {

    let message = ""
    let isOk = true

    if (!this.newEmail) {
      message = "Por favor informe seu novo e-mail"
    } else if (!this.currentPassword) {
      message = "Por favor informe sua senha atual"
    }

    if (message) {
      isOk = false
      this.alertCtrl.create({
        message,
        buttons: ["Ok"]
      }).present()
    }

    return isOk
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/email.ts